<form [formGroup]="assessmentForm" novalidate (ngSubmit)="onSubmit()">

  <div *ngIf="buttonShow">
    <div class="pt-20"></div>
    <div class="center">
      <img src="../../../assets/imgs/icon.png" class="img-fluid2 logo-icon-resize">
    </div>

    <h2 id="b2borb2c" class="h2-blue-light">Welcome</h2>
    <p id="b2borb2c" class="sub-txt">Let's get started! This form will assess your business model.</p>
    <p id="b2borb2c" class="sub-txt">Fill out ALL questions, feel free to take a best guess if you don't know the answer.</p>
    <p id="b2borb2c" class="sub-txt">If you have more than one customer segment, answer customer focused questions according to the customer segment that gives you the most revenue.</p>
    <p id="b2borb2c" class="sub-txt">Note: The assessment is not timed but you must complete the assessment in one session. Your answers don't save if you don't submit the assessment. </p>
    <div class="pt-2"></div>
    <div class="btn-group">
      <button mat-raised-button class="btn-blue-royal" (click)="toggleStart()"> Start</button>
    </div>
  </div>

  <div *ngIf="showAll">
    <mat-tab-group [selectedIndex]="tabNum">

      <!--Business information-->
      <mat-tab label="Business Information">
        <mat-card class="card">
          <mat-card-header>
            <mat-card-title>Business Information</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput placeholder="Business Name*" formControlName="busiName">
                  <mat-error *ngIf="assessmentForm.controls['busiName'].hasError('required')">
                    Business Name is
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput placeholder="First name*" formControlName="busiFirstName">
                  <mat-error *ngIf="assessmentForm.controls['busiFirstName'].hasError('required')">
                    First name is
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput placeholder="Last name*" formControlName="busiLastName">
                  <mat-error *ngIf="assessmentForm.controls['busiLastName'].hasError('required')">
                    Last name is
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput placeholder="Email*" type="email" formControlName="busiEmail">
                  <mat-error *ngIf="assessmentForm.controls['busiEmail'].hasError('required')">
                    Email
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput placeholder="Phone Number*" type="tel" formControlName="busiTelephone">
                  <mat-error *ngIf="assessmentForm.controls['busiTelephone'].hasError('required')">
                    Phone number
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <!-- TODO: Chrome suggests this option as a password -->

                  <input matInput placeholder="Website" type="url" formControlName="busiWebsite" >
                </mat-form-field>
              </div>
            </div>
            <!--  <div class="row">
          <div class="col">
            <mat-form-field class="full-width">
              <textarea matInput placeholder="Street" formControlName="busiStreet"></textarea>
              <mat-error *ngIf="assessmentForm.controls['busiStreet'].hasError('required')">
                Address is
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field class="full-width">
              <input matInput placeholder="City" formControlName="busiCity">
              <mat-error *ngIf="assessmentForm.controls['busiCity'].hasError('required')">
                City is
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row" *ngIf="!hasUnitNumber">
          <div class="col">
            <button mat-button type="button" (click)="hasUnitNumber = !hasUnitNumber">
              + Add C/O, Apt, Suite, Unit
            </button>
          </div>
        </div>
        <div class="row" *ngIf="hasUnitNumber">
          <div class="col">
            <mat-form-field class="full-width">
              <textarea matInput placeholder="Address 2" formControlName="busiaddress2"></textarea>
            </mat-form-field>
          </div>
        </div> -->
            <div class="row">

              <!--  <div class="col">
            <mat-form-field class="full-width">
              <mat-select placeholder="State" formControlName="busiState">
                <mat-option *ngFor="let state of states" [value]="state.abbreviation">
                  {{ state.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="assessmentForm.controls['busiState'].hasError('required')">
                State is
              </mat-error>
            </mat-form-field>
          </div>-->
              <div class="col">
                <mat-form-field class="full-width">
                  <input matInput #postalCode maxlength="5" placeholder="Postal Code" type="number"
                    formControlName="busiZipcode">
                  <mat-hint align="end">{{postalCode.value.length}} / 5</mat-hint>
                  <mat-error *ngIf="assessmentForm.controls['busiZipcode'].hasError('required')">
                    What is your postal code?
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>Are you looking for financing or capital?</label>
                  <mat-select placeholder=" " formControlName="capitalSeeking">
                    <mat-option *ngFor="let cSeeking of boolAnswer" [value]="cSeeking">
                      {{ cSeeking.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['capitalSeeking']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
              <!--  <div class="col">
            <mat-form-field class="full-width">
              <mat-select placeholder="Choose the area that your business is concentrated in" formControlName="busiLocation" multiple>
                <mat-option *ngFor="let location of busiLocation" [value]="location">
                  {{ location.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="assessmentForm.controls['busiLocation'].hasError('required')">
                Select one
              </mat-error>
            </mat-form-field>
          </div>-->
            </div>

          </mat-card-content>
        </mat-card>
        <button mat-raised-button class="btn-blue-royal next-btn" color="primary" type="button" (click)="nextTab()">Next
          <mat-icon> keyboard_arrow_right</mat-icon>
        </button>
      </mat-tab>

      <!--product information-->
      <mat-tab label="Product Information">
        <mat-card class="card">
          <mat-card-header>
            <mat-card-title>Your Business Features</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label> 1a. What is your business primarily offering?
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="Ex. Bookkeeping is a service; a book is a product">info</mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="offerType">
                    <mat-option  *ngFor="let offer of offerType" [value]="offer">
                      {{offer.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerType'].hasError('required')">
                    Please select an offering type
                  </mat-error>
                </mat-form-field>
              </div>
              
              <div class="col">
                <mat-form-field class="full-width">
                  <label> 2. What industry is your business in? </label>
                  <mat-select placeholder="" formControlName="offerIndustry">
                    <mat-option (onSelectionChange)="handleNighttimeEconomyQ1($event, industry.name)" 
                    *ngFor="let industry of offerIndustry" [value]="industry">
                      {{industry.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerIndustry'].hasError('required')">
                    Please select an industry
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col" #iNEQ1 style="display:none">
                <mat-form-field class="full-width">
                  <label> 2a. What will you be serving? </label>
                  <mat-select placeholder="" formControlName="industryNEServing" multiple>
                    <mat-option *ngFor="let NEServing of industryNEServing" [value]="NEServing">
                      {{NEServing.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['industryNEServing'].hasError('required')">
                    Please select an industry
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <label>
              <h3>How Big is the Problem You're Solving?</h3>
            </label>
            <!--problem importance-->
            <div class="row">
              <!-- <div class="col">
          <mat-form-field class="full-width">
          <label>What condition is the market size compared to others?</label>
          <mat-select placeholder="" formControlName="offerMarkSize">
          <mat-option *ngFor="let oMarkSize of offerMarkSize" [value]="oMarkSize">
          {{oMarkSize.name}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="assessmentForm.controls['offerMarkSize'].hasError('required')">
      Please select offer market size
    </mat-error>
  </mat-form-field>
</div>-->
              <!--<div class="col">
                <mat-form-field class="full-width">
                  <label>3. Would your business have been classified as essential during the COVID-19 pandemic?
                    <mat-icon class="matTooltip" matSuffix matTooltip="Ex. Daycare or medical services">info</mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="offerEssential">
                    <mat-option *ngFor="let oEssential of offerEssential" [value]="oEssential">  changetag
                    {{oEssential.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerEssential'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>-->
              <div class="col">
                <mat-form-field class="full-width">
                  <label>3. How frequent would your customer buy from your business?
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="Example: A rider rides the bus (the offering) twice a day">info
                    </mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="offerFrequency">
                    <mat-option *ngFor="let oFrequency of offerFrequency" [value]="oFrequency">
                      {{oFrequency.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerFrequency'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>4. How high of a priority would your product or service rank in your customer's monthly budget?
                  </label>
                  <!--changetag -->
                  <!--  <a class="modal-click" (click)="modal.openSDGHelp()">
                    <mat-icon matSuffix>info</mat-icon>
                  </a>-->
                  <mat-select placeholder="" formControlName="offerUrgency">
                    <mat-option *ngFor="let oUrgency of offerUrgency" [value]="oUrgency">
                      {{oUrgency.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerUrgency'].hasError('required')">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <label>
              <h3>How is Your Product or Service Different?</h3>
            </label>
            <!--offer innovation-->
            <div class="row">
              <div *ngIf="showQuestion" class="col">
                <!--<a class="modal-click" (click)="modal.openOfferHelp()">
    <mat-icon matSuffix>info</mat-icon>
  </a>-->
                <mat-form-field class="full-width">
                  <label>5. Which situation best relates to your business idea/model? Finish the sentence, "My business..."
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="Example: The first ride sharing app was much different than the regular taxi business ">
                      info</mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="offerInnovation">
                    <mat-option *ngFor="let oInnovation of offerInnovation" [value]="oInnovation">
                      {{oInnovation.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerInnovation'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>6. How is your business different than competitors?
                      <mat-icon class="matTooltip" matSuffix matTooltip="Differentiation is how the offering may differ from competitors or substitutes">info</mat-icon>
                    </label>
                    <mat-select *ngIf="!isNonePI6" placeholder="" formControlName="offerDifferentiation"  multiple >
                          <mat-option *ngFor="let oDiff of offerDifferentiationFull"  [value]="oDiff"  > {{oDiff.name}} </mat-option>
                          <mat-option (onSelectionChange)="isNoneSelected(26)"  *ngFor="let oDiff of noneAbove"  [value]="oDiff">  {{oDiff.name}}</mat-option>
                    </mat-select>
                    <mat-select *ngIf="isNonePI6" placeholder=""  formControlName="offerDifferentiation" multiple>          
                          <mat-option (click)="isNoneSelected(26)"  *ngFor="let oDiff of noneAbove"  [value]="oDiff" selected > {{oDiff.name}} </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['offerDifferentiation'].hasError('required')"> Please select one differentiation </mat-error>
                  </mat-form-field>   
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>7. If any, what part of the customer’s life will improve because of your business?</label>
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip="Think about how it may relate to their survival, income or convenience">info
                    </mat-icon>
                    <mat-select *ngIf="!isNonePI7" placeholder="" formControlName="offerImproveLife" multiple >
                      <mat-option *ngFor="let  oImproveLife of offerImproveLifeFull"  [value]=" oImproveLife"  >  {{ oImproveLife.name}}   </mat-option>
                      <mat-option (onSelectionChange)="isNoneSelected(27)" *ngFor="let  oImproveLife of noneAbove"  [value]=" oImproveLife"  > {{ oImproveLife.name}} </mat-option>                    
                    </mat-select>
                    <mat-select *ngIf="isNonePI7" placeholder=""  formControlName="offerImproveLife" multiple>                            
                      <mat-option (click)="isNoneSelected(27)" *ngFor="let  oImproveLife of noneAbove"  [value]=" oImproveLife"   selected > {{ oImproveLife.name}} </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['offerImproveLife']">
                      Please select all that apply
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            <label>
              <h3>What is the Condition of Your Industry?</h3>
            </label>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>8. What barriers could you possibly run into while starting or operating this business? Select all that apply</label>
                  <a class="modal-click" (click)="modal.openMarkEntryHelp()">
                    <mat-icon class="matTooltip" matSuffix>info</mat-icon>
                  </a>
                  <mat-select *ngIf="!isNonePI8" placeholder="" formControlName="offerMarkEntry" multiple >
                   <span *ngFor="let  markEntry of offerMarkEntry"  >
                      <mat-option  *ngIf="markEntry.value==1" (onSelectionChange)="selectChange($event, markEntry.value, markEntry.name, false, isNonePI8)" [value]=" markEntry"  > 
                        {{markEntry.name}}</mat-option>
                      <mat-option  *ngIf="markEntry.value==0" (onSelectionChange)="selectChange($event,markEntry.value, markEntry.name, true, isNonePI8)" [value]=" markEntry"  > 
                        {{markEntry.name}}</mat-option>
                   </span>
                  </mat-select>
                  <mat-select *ngIf="isNonePI8" placeholder=""  formControlName="offerMarkEntry" multiple>
                    <span *ngFor="let  markEntry of offerMarkEntry"  >
                       <mat-option  selected *ngIf="markEntry.value==0" (onSelectionChange)="selectChange($event,markEntry.value, markEntry.name, false, isNonePI8)"[value]=" markEntry"  >  
                            {{markEntry.name}}
                      </mat-option>
                   </span>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerMarkEntry'].hasError('required')">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>9. Buyer Power is the power your customer has to demand a lower price from you or higher quality. How much Buyer Power does your customer have?
                    <!--TODO - how vulnerable are your sales to price sensitivty, if the price were to change, how many customers would stay vs leave?-->
                 </label>
                  <mat-select placeholder="" formControlName="offerBuyerPower">
                    <mat-option *ngFor="let oBuyerPower of offerBuyerPower" [value]="oBuyerPower">
                      {{oBuyerPower.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerBuyerPower'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>10. How easy would it be to switch suppliers if you needed to? 
                    <!--TODO - how vulnerable are your sales to price sensitivty, if the price were to change, how many customers would stay vs leave?-->
                  </label>
                  <mat-select placeholder="" formControlName="offerSupplierPower">
                    <mat-option *ngFor="let oSupplierPower of offerSupplierPower" [value]="oSupplierPower">
                      {{oSupplierPower.name}}
                    </mat-option>
                  </mat-select>
                 <mat-error *ngIf="assessmentForm.controls['offerSupplierPower'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>11. Who are the suppliers for your most profitable products/services?</label>     
                  <mat-select *ngIf="!isNonePI11" placeholder="" formControlName="offerSupplierType" multiple >    
                    <mat-option *ngFor="let  oSupplierType of offerSupplierType"  [value]=" oSupplierType"  >  {{oSupplierType.name}}     </mat-option>
                    <mat-option (onSelectionChange)="isNoneSelected(211)"  *ngFor="let oSupplierType of offerSupplierTypeNone"  [value]=" oSupplierType"> {{oSupplierType.name}} </mat-option>
                  </mat-select>
                  <mat-select *ngIf="isNonePI11" placeholder=""  formControlName="offerSupplierType" multiple>
                         
                    <mat-option  (click)="isNoneSelected(211)"  *ngFor="let oSupplierType of offerSupplierTypeNone"  [value]=" oSupplierType" selected > {{oSupplierType.name}}  </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['offerSupplierType']">
                    Please select all that apply
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <button type="button" mat-raised-button class="btn-blue-royal next-btn" color="primary" (click)="nextTab()">Next
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
        <button type="button" mat-raised-button class="btn-blue-royal prv-btn" color="primary" (click)="prevTab()">
          <mat-icon>keyboard_arrow_left</mat-icon> Previous
        </button>
      </mat-tab>
      <!--Market-->
      <mat-tab label="Market">
        <mat-card class="card">
          <!-- Busines to Business-->
          <div>
            <mat-card-header>
              <mat-card-title>Target Market</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <label>
                <h3>Understanding Your Target Customer</h3>
              </label>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>1. Are you selling to consumers or to other businesses? If both, choose your main stream of revenue.</label>
                    <mat-select placeholder="" formControlName="marketTargetB2BC">
                      <mat-option *ngFor="let mTargetB2BC of marketTargetB2BC" (onSelectionChange)="handleB2BC($event, mTargetB2BC.name)" [value]="mTargetB2BC">
                        {{ mTargetB2BC.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetB2BC'].hasError('required')">
                      Please enter the business selling type
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>2. What's the largest market location you could potentially serve within the next 3 years? </label>
                    <mat-select placeholder="" formControlName="marketTargetLocation">
                      <mat-option *ngFor="let mTargetLocation of marketTargetLocation" [value]="mTargetLocation">
                        {{mTargetLocation.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetLocation'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div #B2B style="display:none"> 
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>3. What is the target business industry?</label>
                    <mat-select placeholder="" formControlName="marketTargetB2BIndustry">
                      <mat-option *ngFor="let mmarketTargetB2BIndustry of marketTargetB2BIndustry"
                        [value]="mmarketTargetB2BIndustry">
                        {{mmarketTargetB2BIndustry.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetB2BIndustry'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>4. Who is your point of contact within the organization that you are selling to?</label>
                    <mat-select placeholder="" formControlName="marketTargetB2BOccupation">
                      <mat-option *ngFor="let mmarketTargetB2BOccupation of marketTargetB2BOccupation"
                        [value]="mmarketTargetB2BOccupation">
                        {{mmarketTargetB2BOccupation.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetB2BIndustry'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>5. Is the point of contact a decision maker within the organization?</label>
                    <mat-select placeholder="" formControlName="marketTargetB2BDecisionMaker">
                      <mat-option *ngFor="let mmarketTargetB2BDecisionMaker of marketTargetB2BDecisionMaker"
                        [value]="mmarketTargetB2BDecisionMaker">
                        {{mmarketTargetB2BDecisionMaker.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetB2BDecisionMaker'].hasError('required')">
                      Please select one
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          <div #B2C style="display:none">
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>3. What is your main target customer's age range? </label>
                    <mat-select placeholder="" formControlName="marketTargetAge" >
                      <mat-option *ngFor="let mTargetAge of marketTargetAge" [value]="mTargetAge">
                        {{ mTargetAge.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetAge'].hasError('required')">
                      Please enter the target age range
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>4. What is your main target customer's ethnicity?</label>
                    <mat-select placeholder="" formControlName="marketTargetEthnicity">
                      <mat-option *ngFor="let mTargetEthnicity of marketTargetEthnicity" [value]="mTargetEthnicity">
                        {{ mTargetEthnicity.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetEthnicity'].hasError('required')">
                      Please enter the target ethnic group
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>5. What is your main target customer's gender?</label>
                    <mat-select placeholder="" formControlName="marketTargetGender">
                      <mat-option *ngFor="let mTargetGender of marketTargetGender" [value]="mTargetGender">
                        {{ mTargetGender.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetGender'].hasError('required')">
                      Please enter the target gender
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>6. What is your main target customer's occupation?</label>
                    <mat-select placeholder="" formControlName="marketTargetOccupation">
                      <mat-option *ngFor="let mTargetOccupation of marketTargetOccupation" [value]="mTargetOccupation">
                        {{ mTargetOccupation.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['marketTargetOccupation'].hasError('required')">
                      Please enter the target occupation
                    </mat-error>
                  </mat-form-field>
                </div>
                </div>
                </div>
              <label>
                <h3>Understanding Your Competitors</h3>
              </label>
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>7. How many known competitors, or substitutes, do you have? </label>
                    <mat-select placeholder="" formControlName="pmfOverproduction">
                      <mat-option *ngFor="let mOverproduction of pmfOverproduction" [value]="mOverproduction">
                        {{mOverproduction.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['pmfOverproduction'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>8. In which case do you think customers are dissatisfied with competitors?</label>  
                          <mat-select *ngIf="!isNoneMI8" placeholder="" formControlName="pmfCompetitorDissatisfaction" multiple >
                                        <mat-option
                                         *ngFor="let mCompetitorDissatisfaction of pmfCompetitorDissatisfactionFull"      [value]="mCompetitorDissatisfaction">
                                                  {{mCompetitorDissatisfaction.name}}
                                        </mat-option>
                                        <!-- <mat-option (onSelectionChange)="isNoneSelected(211)"  *ngFor="let oSupplierType of offerSupplierTypeNone"> {{oSupplierType.name}} </mat-option> -->
                                        <mat-option (click)="isNoneSelected(38)" *ngFor="let nbv of noneAbove" [value]="nbv">
                                                  {{nbv.name}}
                                        </mat-option>
                          </mat-select>
                          <mat-select *ngIf="isNoneMI8" placeholder=""  formControlName="pmfCompetitorDissatisfaction" multiple>
                                    <mat-option (click)="isNoneSelected(38)"  *ngFor="let mCompetitorDissatisfaction of noneAbove" [value]="mCompetitorDissatisfaction" selected >
                                             {{mCompetitorDissatisfaction.name}}
                                    </mat-option>
                          </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['pmfCompetitorDissatisfaction'].hasError('required')">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
        <button type="button" mat-raised-button class="btn-blue-royal next-btn" color="primary" type="button"
          (click)="nextTab()">Next
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
        <button type="button" mat-raised-button class="btn-blue-royal prv-btn" color="primary" (click)="prevTab()">
          <mat-icon>keyboard_arrow_left</mat-icon> Previous
        </button>
        </div>
        </mat-card>
      </mat-tab>

      <!--Practicality-->
     
      <!--Team-->
      <mat-tab label="Team">
        <mat-card class="card">
          <mat-card-header>
            <mat-card-title>Team Dynamics</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <label>
              <h3>What is the Team's Technical Capability?</h3>
            </label>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>1. Has anyone on the core or executive team started or managed a business before?</label>
                  <mat-select placeholder="" formControlName="teamLeaderSerialEntrp">
                    <mat-option *ngFor="let tLeaderSerialEntrp of boolAnswer" [value]="tLeaderSerialEntrp">
                      {{ tLeaderSerialEntrp.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamLeaderSerialEntrp']">
                    Please select yes or no
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>2. What skills are your team strong in?
                  </label>
                
                  <mat-select *ngIf="!isNoneT2" placeholder="" formControlName="teamRole" multiple >
                            <mat-option *ngFor="let tRole of teamRoleFull"  [value]="tRole"> {{tRole.name}} </mat-option>
                            <mat-option (onSelectionChange)="isNoneSelected(42)"  *ngFor="let tRole of noneAbove"  [value]="tRole">     {{tRole.name}} </mat-option>                   
                  </mat-select>
                  <mat-select *ngIf="isNoneT2" placeholder=""  formControlName="teamRole" multiple>                         
                            <mat-option (click)="isNoneSelected(42)" *ngFor="let tRole of noneAbove"  [value]="tRole" selected >    {{tRole.name}}  </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamRole'].hasError('required')">
                    Please select all that apply
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>3. How many team members are on the team?</label>
                  <mat-icon class="matTooltip" matSuffix
                  matTooltip="Including full, part-time, contractors, etc.">info
                </mat-icon>
                  <input matInput type="number" placeholder="" formControlName="teamMembersQuan"
                    [(ngModel)]="teamMembersQuanCheck" (change)="hideQ15to17()">
                  <mat-error *ngIf="assessmentForm.controls['teamMembersQuan']">
                    Please enter a number
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>4. How well does the team know the business industry? </label>
                  <mat-icon class="matTooltip" matSuffix
                    matTooltip=" Industry knowledge is background or experience in the field">info
                  </mat-icon>
                  <mat-select placeholder="" formControlName="teamIndustryKnowledge">
                    <mat-option *ngFor="let tIndustryKnowledge of teamIndustryKnowledge" [value]="tIndustryKnowledge">
                      {{ tIndustryKnowledge.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamIndustryKnowledge']">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>5. How much time do most team members have to dedicate to the business per week? </label>
                  <mat-select placeholder="" formControlName="teamTime">
                    <mat-option *ngFor="let tTime of teamTime" [value]="tTime">
                      {{ tTime.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamTime']">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <label>
              <h3>What is the Execution Ability of the Team?</h3>
            </label>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>6. What is the ability of the team to develop or sell the product or service through its
                    network?
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip=" Think about the ability to develop the product/service and sales funnels.">info
                    </mat-icon>
                  </label>
                  <mat-select placeholder="" formControlName="teamNetwork">
                    <mat-option *ngFor="let tNetwork of teamNetwork" [value]="tNetwork">
                      {{tNetwork.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamNetwork'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>  
              <div class="col"> 
               
                <mat-form-field class="full-width">
                  <label>7. What challenges have you already overcome to start the business? Select all that apply
                    <mat-icon class="matTooltip" matSuffix
                      matTooltip=" Unfair advantages are the market barriers (selected above) that the team has already overcome">
                      info</mat-icon>
                  </label> 
                  <mat-select *ngIf="!isNoneTI7" placeholder="" formControlName="teamUnadv" [value]="assessmentForm.controls.teamUnadv.value" multiple >
                       <mat-option *ngFor="let  tUnfairAdvantage of teamUnadvFull"    [value]=" tUnfairAdvantage"  >  
                              {{tUnfairAdvantage.name}}
                        </mat-option>
                      <mat-option (click)="isNoneSelected(47)" *ngFor="let tUnfairAdvantage of noneAbove" [value]="tUnfairAdvantage" >
                          {{tUnfairAdvantage.name}}
                      </mat-option>
                   </mat-select>
                   <mat-select *ngIf="isNoneTI7" placeholder=""  formControlName="teamUnadv" multiple>
                        <mat-option (click)="isNoneSelected(47)" *ngFor="let tUnfairAdvantage of noneAbove" [value]="tUnfairAdvantage" >
                            {{tUnfairAdvantage.name}}
                        </mat-option>
                   </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamUnadv'].hasError('required')">
                    Please select an answer
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>8. What is the team’s ability to set, prioritize, track and meet goals when given a
                    timeline?</label>
                  <mat-select placeholder="" formControlName="teamTimeManage">
                    <mat-option *ngFor="let tTimeManage of teamTimeManage" [value]="tTimeManage">
                      {{tTimeManage.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamTimeManage'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>9. How accountable are the team members to the team and its progress?</label>
                  <mat-select placeholder="" formControlName="teamAccountability">
                    <mat-option *ngFor="let tAccountability of teamAccountability" [value]="tAccountability">
                      {{tAccountability.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamAccountability'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>10. How often does the team encounter internal dysfunction or unproductivity?</label>
                  <mat-select placeholder="" formControlName="teamUnproductivity">
                    <mat-option *ngFor="let tProductivity of teamUnproductivity" [value]="tProductivity">
                      {{tProductivity.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamUnproductivity'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <label>
              <h3>What is the Team Disposition?</h3>
            </label>
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <label>11. How passionate is the team about the business?</label>
                  <mat-select placeholder="" formControlName="teamPassion">
                    <mat-option *ngFor="let tPassion of teamPassion" [value]="tPassion">
                      {{tPassion.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamPassion'].hasError('required')">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <label>12. How well can the team handle risk if faced?</label>
                  <mat-select placeholder=" " formControlName="teamRisk">
                    <mat-option *ngFor="let tRisk of teamRisk" [value]="tRisk">
                      {{ tRisk.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="assessmentForm.controls['teamRisk']">
                    Please select one
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div *ngIf="teamMemberHTMLVar">
              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>13. At what level does the team agree with the statement “Team members openly admit mistakes
                      or
                      problems”?</label>
                    <mat-select placeholder="" formControlName="teamOpenness">
                      <mat-option *ngFor="let tOpenness of teamOpenness" [value]="tOpenness">
                        {{ tOpenness.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['teamOpenness']">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>14. At what level does the team agree with the statement, “We have confidence in each other’s
                      ability to get stuff done”?</label>
                    <mat-select placeholder="" formControlName="teamTrust">
                      <mat-option *ngFor="let tTrust of teamTrust" [value]="tTrust">
                        {{ tTrust.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['teamTrust']">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field class="full-width">
                    <label>15. At what level does the team agree with the statement “the team rewards or recognizes team
                      member contributions, big and small”?</label>
                    <mat-select placeholder="" formControlName="teamRecognition">
                      <mat-option *ngFor="let tRecognition of teamRecognition" [value]="tRecognition">
                        {{ tRecognition.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="assessmentForm.controls['teamRecognition']">
                      Please select an answer
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <mat-checkbox formControlName="acceptTerms" #tc>
                      By selecting 'I agree' and clicking submit, you agree to our <a target="_blank"
                        href="http://sustainible.io/privacy-policy/">Privacy Policy</a> and <a target="_blank"
                        href="http://sustainible.io/terms-conditions/">Terms and Conditions</a>.
                    </mat-checkbox>
                    <mat-error *ngIf="tc.checked">
                      <button class="btn-block btn-blue-royal" mat-raised-button color="primary">Submit</button>
                    </mat-error>
                  </div>
                </div>
                <!--<mat-form-field class="full-width">
          <label>By selecting 'I agree' and clicking submit, you agree to our  <a target="_blank" href="http://sustainible.io/privacy-policy/">Privacy Policy</a> and  <a target="_blank" href="http://sustainible.io/terms-conditions/">Terms and Conditions</a>.
          </label>
          <mat-select placeholder=" "  formControlName = "acceptTerms" >
            <mat-option *ngFor="let aTerms of acceptTerms" [value]="aTerms">
                {{ aTerms.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="assessmentForm.controls['acceptTerms']">
            Required
          </mat-error>
        </mat-form-field>-->
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <button mat-raised-button class="btn-blue-royal next-btn" color="primary" type="button" (click)="prevTab()">
          <mat-icon>keyboard_arrow_left</mat-icon>Previous
        </button>
      </mat-tab>

    </mat-tab-group>
  </div>

</form>
